import { useQuery } from "@apollo/client/react";

import { DIALOG, setDialog } from "@/components/app/dialogs/dialog-provider";
import CoinPriceFormatter from "@/components/shared/coin-price-formatter";
import { TriggerLoggedInModalWindow } from "@/components/shared/is-logged-in";
import { CoinPriceDocument } from "@/graphql/codegen/graphql";
import { MIN_DESO_TOKEN_PCT_CHANGE_TO_HIGHLIGHT_TRENDING } from "@/utils/constants";
import { cn } from "@/utils/lib";

import { CreatorCoinTab } from "./creator-coin-exchange-modal/creator-coin-tabs";

const CoinLivePrice = ({ publicKey }: { publicKey: string }) => {
  const { data, loading } = useQuery(CoinPriceDocument, {
    variables: { coinPublicKey: publicKey },
    skip: !publicKey,
  });

  const colorClass = loading
    ? ""
    : (data?.daoCoinStatByCoinPublicKey?.volumeUsdPast24H ?? 0) >
        MIN_DESO_TOKEN_PCT_CHANGE_TO_HIGHLIGHT_TRENDING
      ? "text-green-500"
      : "text-muted";

  const visiblePrice = data?.daoCoinStatByCoinPublicKey?.priceUsd ?? 0;

  if (loading || visiblePrice === 0) {
    return null;
  }

  return (
    <>
      <span
        className="
          mx-1 hidden text-xs font-light text-muted
          md:inline-block
        "
      >
        &bull;
      </span>
      <div
        className="
          w-full
          md:mt-0 md:w-auto
        "
      >
        <TriggerLoggedInModalWindow>
          <div
            className={cn(
              `
                group cursor-pointer font-mono text-xs underline-offset-4
                hover:underline
              `,
              colorClass,
            )}
            role="button"
            onClickCapture={(event) => {
              event.stopPropagation();
              setDialog(DIALOG.TradeCoin, {
                open: true,
                params: {
                  publicKey,
                  tab: CreatorCoinTab.Buy,
                },
              });
            }}
          >
            <CoinPriceFormatter
              price={visiblePrice}
              className="
                text-xs underline-offset-4
                group-hover:underline
              "
            />
          </div>
        </TriggerLoggedInModalWindow>
      </div>
    </>
  );
};

export default CoinLivePrice;
